import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import { services } from "../data/profile";
import { Reveal, Overline, AnimatedHeading } from "./Reveal";

const SERVICE_IMG =
  "https://images.unsplash.com/photo-1709497197725-2e97c76b31d0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000";

export const Services = () => {
  const go = () => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
  return (
    <section id="services" className="py-16 sm:py-20 lg:py-24 bg-white border-y border-[#E2E5E1]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-6 order-2 lg:order-1">
            <Reveal>
              <Overline>Consultancy Services</Overline>
              <AnimatedHeading className="font-display text-3xl sm:text-4xl font-bold text-navy tracking-tight mt-4 leading-snug">
                Partner with a proven healthcare leader.
              </AnimatedHeading>
              <p className="mt-4 text-lg" style={{ color: "#4B5A69" }}>
                Strategic advisory for hospitals and medical colleges seeking accreditation, operational
                excellence and sustainable growth.
              </p>
            </Reveal>
            <div className="mt-8 grid sm:grid-cols-2 gap-x-8 gap-y-4">
              {services.map((s, i) => (
                <Reveal key={s} delay={i * 0.04}>
                  <div className="flex items-start gap-3 group" data-testid={`service-${i}`}>
                    <span className="mt-1 h-3.5 w-3.5 rotate-45 bg-gradient-to-br from-gold to-teal shrink-0 transition-all duration-500 group-hover:rotate-[225deg] group-hover:scale-125 shadow-sm" />
                    <span className="text-sm font-medium text-navy group-hover:translate-x-1.5 group-hover:text-teal transition-all duration-300">{s}</span>
                  </div>
                </Reveal>
              ))}
            </div>
            <Reveal delay={0.2}>
              <button
                data-testid="services-cta-btn"
                onClick={go}
                className="group mt-10 inline-flex items-center gap-2 px-7 py-3.5 rounded-md bg-navy text-bone font-medium hover:bg-teal transition-colors"
              >
                Discuss Your Requirement
                <ArrowUpRight size={18} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
              </button>
            </Reveal>
          </div>
          <div className="lg:col-span-6 order-1 lg:order-2">
            <Reveal delay={0.1}>
              <div className="relative">
                <div className="absolute -inset-3 rounded-3xl border border-gold/30 -z-10" />
                <div className="img-zoom rounded-2xl border border-[#E2E5E1] overflow-hidden">
                  <img
                    src={SERVICE_IMG}
                    alt="Healthcare consultancy"
                    className="w-full h-[420px] object-cover"
                  />
                </div>
                {/* India flag badge in front of the hospital photo */}
                <motion.div
                  initial={{ opacity: 0, y: 20, scale: 0.9 }}
                  whileInView={{ opacity: 1, y: 0, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.3, type: "spring" }}
                  data-testid="india-flag-badge"
                  className="absolute bottom-4 left-4 sm:-left-5 flex items-center gap-3 bg-white/95 backdrop-blur-md rounded-xl px-4 py-3 shadow-xl border border-[#E2E5E1]"
                >
                  <img
                    src="https://flagcdn.com/w160/in.png"
                    alt="Flag of India"
                    className="h-8 w-12 object-cover rounded-[3px] shadow-sm ring-1 ring-black/5"
                  />
                  <span className="leading-tight">
                    <span className="block text-[0.6rem] font-plex uppercase tracking-widest text-gold">Proudly Serving</span>
                    <span className="block text-sm font-bold text-navy">Indian Healthcare</span>
                  </span>
                </motion.div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
